const defaultTimezone = [
  {
    id: 0,
    name: 'International Date Line West',
    zone: 'Etc/GMT+12'
  },
  {
    id: 1,
    name: 'Midway Island',
    zone: 'Pacific/Midway'
  },
  {
    id: 2,
    name: 'American Samoa',
    zone: 'Pacific/Pago_Pago'
  },
  {
    id: 3,
    name: 'Hawaii',
    zone: 'Pacific/Honolulu'
  },
  {
    id: 4,
    name: 'Alaska',
    zone: 'America/Juneau'
  },
  {
    id: 5,
    name: 'Pacific Time (US & Canada)',
    zone: 'America/Los_Angeles'
  },
  {
    id: 6,
    name: 'Tijuana',
    zone: 'America/Tijuana'
  },
  {
    id: 7,
    name: 'Mountain Time (US & Canada)',
    zone: 'America/Denver'
  },
  {
    id: 8,
    name: 'Arizona',
    zone: 'America/Phoenix'
  },
  {
    id: 9,
    name: 'Chihuahua',
    zone: 'America/Chihuahua'
  },
  {
    id: 10,
    name: 'Mazatlan',
    zone: 'America/Mazatlan'
  },
  {
    id: 11,
    name: 'Central Time (US & Canada)',
    zone: 'America/Chicago'
  },
  {
    id: 12,
    name: 'Saskatchewan',
    zone: 'America/Regina'
  },
  {
    id: 13,
    name: 'Guadalajara',
    zone: 'America/Mexico_City'
  },
  {
    id: 14,
    name: 'Mexico City',
    zone: 'America/Mexico_City'
  },
  {
    id: 15,
    name: 'Monterrey',
    zone: 'America/Monterrey'
  },
  {
    id: 16,
    name: 'Central America',
    zone: 'America/Guatemala'
  },
  {
    id: 17,
    name: 'Eastern Time (US & Canada)',
    zone: 'America/New_York'
  },
  {
    id: 18,
    name: 'Indiana (East)',
    zone: 'America/Indiana/Indianapolis'
  },
  {
    id: 19,
    name: 'Bogota',
    zone: 'America/Bogota'
  },
  {
    id: 20,
    name: 'Lima',
    zone: 'America/Lima'
  },
  {
    id: 21,
    name: 'Quito',
    zone: 'America/Lima'
  },
  {
    id: 22,
    name: 'Atlantic Time (Canada)',
    zone: 'America/Halifax'
  },
  {
    id: 23,
    name: 'Caracas',
    zone: 'America/Caracas'
  },
  {
    id: 24,
    name: 'La Paz',
    zone: 'America/La_Paz'
  },
  {
    id: 25,
    name: 'Santiago',
    zone: 'America/Santiago'
  },
  {
    id: 26,
    name: 'Newfoundland',
    zone: 'America/St_Johns'
  },
  {
    id: 27,
    name: 'Brasilia',
    zone: 'America/Sao_Paulo'
  },
  {
    id: 28,
    name: 'Buenos Aires',
    zone: 'America/Argentina/Buenos_Aires'
  },
  {
    id: 29,
    name: 'Montevideo',
    zone: 'America/Montevideo'
  },
  {
    id: 30,
    name: 'Georgetown',
    zone: 'America/Guyana'
  },
  {
    id: 31,
    name: 'Puerto Rico',
    zone: 'America/Puerto_Rico'
  },
  {
    id: 32,
    name: 'Greenland',
    zone: 'America/Godthab'
  },
  {
    id: 33,
    name: 'Mid-Atlantic',
    zone: 'Atlantic/South_Georgia'
  },
  {
    id: 34,
    name: 'Azores',
    zone: 'Atlantic/Azores'
  },
  {
    id: 35,
    name: 'Cape Verde Is.',
    zone: 'Atlantic/Cape_Verde'
  },
  {
    id: 36,
    name: 'Dublin',
    zone: 'Europe/Dublin'
  },
  {
    id: 37,
    name: 'Edinburgh',
    zone: 'Europe/London'
  },
  {
    id: 38,
    name: 'Lisbon',
    zone: 'Europe/Lisbon'
  },
  {
    id: 39,
    name: 'London',
    zone: 'Europe/London'
  },
  {
    id: 40,
    name: 'Casablanca',
    zone: 'Africa/Casablanca'
  },
  {
    id: 41,
    name: 'Monrovia',
    zone: 'Africa/Monrovia'
  },
  {
    id: 42,
    name: 'UTC',
    zone: 'Etc/UTC'
  },
  {
    id: 43,
    name: 'Belgrade',
    zone: 'Europe/Belgrade'
  },
  {
    id: 44,
    name: 'Bratislava',
    zone: 'Europe/Bratislava'
  },
  {
    id: 45,
    name: 'Budapest',
    zone: 'Europe/Budapest'
  },
  {
    id: 46,
    name: 'Ljubljana',
    zone: 'Europe/Ljubljana'
  },
  {
    id: 47,
    name: 'Prague',
    zone: 'Europe/Prague'
  },
  {
    id: 48,
    name: 'Sarajevo',
    zone: 'Europe/Sarajevo'
  },
  {
    id: 49,
    name: 'Skopje',
    zone: 'Europe/Skopje'
  },
  {
    id: 50,
    name: 'Warsaw',
    zone: 'Europe/Warsaw'
  },
  {
    id: 51,
    name: 'Zagreb',
    zone: 'Europe/Zagreb'
  },
  {
    id: 52,
    name: 'Brussels',
    zone: 'Europe/Brussels'
  },
  {
    id: 53,
    name: 'Copenhagen',
    zone: 'Europe/Copenhagen'
  },
  {
    id: 54,
    name: 'Madrid',
    zone: 'Europe/Madrid'
  },
  {
    id: 55,
    name: 'Paris',
    zone: 'Europe/Paris'
  },
  {
    id: 56,
    name: 'Amsterdam',
    zone: 'Europe/Amsterdam'
  },
  {
    id: 57,
    name: 'Berlin',
    zone: 'Europe/Berlin'
  },
  {
    id: 58,
    name: 'Bern',
    zone: 'Europe/Zurich'
  },
  {
    id: 59,
    name: 'Zurich',
    zone: 'Europe/Zurich'
  },
  {
    id: 60,
    name: 'Rome',
    zone: 'Europe/Rome'
  },
  {
    id: 61,
    name: 'Stockholm',
    zone: 'Europe/Stockholm'
  },
  {
    id: 62,
    name: 'Vienna',
    zone: 'Europe/Vienna'
  },
  {
    id: 63,
    name: 'West Central Africa',
    zone: 'Africa/Algiers'
  },
  {
    id: 64,
    name: 'Bucharest',
    zone: 'Europe/Bucharest'
  },
  {
    id: 65,
    name: 'Cairo',
    zone: 'Africa/Cairo'
  },
  {
    id: 66,
    name: 'Helsinki',
    zone: 'Europe/Helsinki'
  },
  {
    id: 67,
    name: 'Kyiv',
    zone: 'Europe/Kiev'
  },
  {
    id: 68,
    name: 'Riga',
    zone: 'Europe/Riga'
  },
  {
    id: 69,
    name: 'Sofia',
    zone: 'Europe/Sofia'
  },
  {
    id: 70,
    name: 'Tallinn',
    zone: 'Europe/Tallinn'
  },
  {
    id: 71,
    name: 'Vilnius',
    zone: 'Europe/Vilnius'
  },
  {
    id: 72,
    name: 'Athens',
    zone: 'Europe/Athens'
  },
  {
    id: 73,
    name: 'Istanbul',
    zone: 'Europe/Istanbul'
  },
  {
    id: 74,
    name: 'Minsk',
    zone: 'Europe/Minsk'
  },
  {
    id: 75,
    name: 'Jerusalem',
    zone: 'Asia/Jerusalem'
  },
  {
    id: 76,
    name: 'Harare',
    zone: 'Africa/Harare'
  },
  {
    id: 77,
    name: 'Pretoria',
    zone: 'Africa/Johannesburg'
  },
  {
    id: 78,
    name: 'Kaliningrad',
    zone: 'Europe/Kaliningrad'
  },
  {
    id: 79,
    name: 'Moscow',
    zone: 'Europe/Moscow'
  },
  {
    id: 80,
    name: 'St. Petersburg',
    zone: 'Europe/Moscow'
  },
  {
    id: 81,
    name: 'Volgograd',
    zone: 'Europe/Volgograd'
  },
  {
    id: 82,
    name: 'Samara',
    zone: 'Europe/Samara'
  },
  {
    id: 83,
    name: 'Kuwait',
    zone: 'Asia/Kuwait'
  },
  {
    id: 84,
    name: 'Riyadh',
    zone: 'Asia/Riyadh'
  },
  {
    id: 85,
    name: 'Nairobi',
    zone: 'Africa/Nairobi'
  },
  {
    id: 86,
    name: 'Baghdad',
    zone: 'Asia/Baghdad'
  },
  {
    id: 87,
    name: 'Tehran',
    zone: 'Asia/Tehran'
  },
  {
    id: 88,
    name: 'Abu Dhabi',
    zone: 'Asia/Muscat'
  },
  {
    id: 89,
    name: 'Muscat',
    zone: 'Asia/Muscat'
  },
  {
    id: 90,
    name: 'Baku',
    zone: 'Asia/Baku'
  },
  {
    id: 91,
    name: 'Tbilisi',
    zone: 'Asia/Tbilisi'
  },
  {
    id: 92,
    name: 'Yerevan',
    zone: 'Asia/Yerevan'
  },
  {
    id: 93,
    name: 'Kabul',
    zone: 'Asia/Kabul'
  },
  {
    id: 94,
    name: 'Ekaterinburg',
    zone: 'Asia/Yekaterinburg'
  },
  {
    id: 95,
    name: 'Islamabad',
    zone: 'Asia/Karachi'
  },
  {
    id: 96,
    name: 'Karachi',
    zone: 'Asia/Karachi'
  },
  {
    id: 97,
    name: 'Tashkent',
    zone: 'Asia/Tashkent'
  },
  {
    id: 98,
    name: 'Chennai',
    zone: 'Asia/Kolkata'
  },
  {
    id: 99,
    name: 'Kolkata',
    zone: 'Asia/Kolkata'
  },
  {
    id: 100,
    name: 'Mumbai',
    zone: 'Asia/Kolkata'
  },
  {
    id: 101,
    name: 'New Delhi',
    zone: 'Asia/Kolkata'
  },
  {
    id: 102,
    name: 'Kathmandu',
    zone: 'Asia/Kathmandu'
  },
  {
    id: 103,
    name: 'Astana',
    zone: 'Asia/Dhaka'
  },
  {
    id: 104,
    name: 'Dhaka',
    zone: 'Asia/Dhaka'
  },
  {
    id: 105,
    name: 'Sri Jayawardenepura',
    zone: 'Asia/Colombo'
  },
  {
    id: 106,
    name: 'Almaty',
    zone: 'Asia/Almaty'
  },
  {
    id: 107,
    name: 'Novosibirsk',
    zone: 'Asia/Novosibirsk'
  },
  {
    id: 108,
    name: 'Rangoon',
    zone: 'Asia/Rangoon'
  },
  {
    id: 109,
    name: 'Bangkok',
    zone: 'Asia/Bangkok'
  },
  {
    id: 110,
    name: 'Hanoi',
    zone: 'Asia/Bangkok'
  },
  {
    id: 111,
    name: 'Jakarta',
    zone: 'Asia/Jakarta'
  },
  {
    id: 112,
    name: 'Krasnoyarsk',
    zone: 'Asia/Krasnoyarsk'
  },
  {
    id: 113,
    name: 'Beijing',
    zone: 'Asia/Shanghai'
  },
  {
    id: 114,
    name: 'Chongqing',
    zone: 'Asia/Chongqing'
  },
  {
    id: 115,
    name: 'Hong Kong',
    zone: 'Asia/Hong_Kong'
  },
  {
    id: 116,
    name: 'Urumqi',
    zone: 'Asia/Urumqi'
  },
  {
    id: 117,
    name: 'Kuala Lumpur',
    zone: 'Asia/Kuala_Lumpur'
  },
  {
    id: 118,
    name: 'Singapore',
    zone: 'Asia/Singapore'
  },
  {
    id: 119,
    name: 'Taipei',
    zone: 'Asia/Taipei'
  },
  {
    id: 120,
    name: 'Perth',
    zone: 'Australia/Perth'
  },
  {
    id: 121,
    name: 'Irkutsk',
    zone: 'Asia/Irkutsk'
  },
  {
    id: 122,
    name: 'Ulaanbaatar',
    zone: 'Asia/Ulaanbaatar'
  },
  {
    id: 123,
    name: 'Seoul',
    zone: 'Asia/Seoul'
  },
  {
    id: 124,
    name: 'Osaka',
    zone: 'Asia/Tokyo'
  },
  {
    id: 125,
    name: 'Sapporo',
    zone: 'Asia/Tokyo'
  },
  {
    id: 126,
    name: 'Tokyo',
    zone: 'Asia/Tokyo'
  },
  {
    id: 127,
    name: 'Yakutsk',
    zone: 'Asia/Yakutsk'
  },
  {
    id: 128,
    name: 'Darwin',
    zone: 'Australia/Darwin'
  },
  {
    id: 129,
    name: 'Adelaide',
    zone: 'Australia/Adelaide'
  },
  {
    id: 130,
    name: 'Canberra',
    zone: 'Australia/Melbourne'
  },
  {
    id: 131,
    name: 'Melbourne',
    zone: 'Australia/Melbourne'
  },
  {
    id: 132,
    name: 'Sydney',
    zone: 'Australia/Sydney'
  },
  {
    id: 133,
    name: 'Brisbane',
    zone: 'Australia/Brisbane'
  },
  {
    id: 134,
    name: 'Hobart',
    zone: 'Australia/Hobart'
  },
  {
    id: 135,
    name: 'Vladivostok',
    zone: 'Asia/Vladivostok'
  },
  {
    id: 136,
    name: 'Guam',
    zone: 'Pacific/Guam'
  },
  {
    id: 137,
    name: 'Port Moresby',
    zone: 'Pacific/Port_Moresby'
  },
  {
    id: 138,
    name: 'Magadan',
    zone: 'Asia/Magadan'
  },
  {
    id: 139,
    name: 'Srednekolymsk',
    zone: 'Asia/Srednekolymsk'
  },
  {
    id: 140,
    name: 'Solomon Is.',
    zone: 'Pacific/Guadalcanal'
  },
  {
    id: 141,
    name: 'New Caledonia',
    zone: 'Pacific/Noumea'
  },
  {
    id: 142,
    name: 'Fiji',
    zone: 'Pacific/Fiji'
  },
  {
    id: 143,
    name: 'Kamchatka',
    zone: 'Asia/Kamchatka'
  },
  {
    id: 144,
    name: 'Marshall Is.',
    zone: 'Pacific/Majuro'
  },
  {
    id: 145,
    name: 'Auckland',
    zone: 'Pacific/Auckland'
  },
  {
    id: 146,
    name: 'Wellington',
    zone: 'Pacific/Auckland'
  },
  {
    id: 147,
    name: "Nuku'alofa",
    zone: 'Pacific/Tongatapu'
  },
  {
    id: 148,
    name: 'Tokelau Is.',
    zone: 'Pacific/Fakaofo'
  },
  {
    id: 149,
    name: 'Chatham Is.',
    zone: 'Pacific/Chatham'
  },
  {
    id: 150,
    name: 'Samoa',
    zone: 'Pacific/Apia'
  }
];
export default defaultTimezone;
